import MD5 from "crypto-js/md5";
import * as configUtils from "../controller/utils/configUtils";
import * as nodeUtils from "../controller/utils/nodeUtils";
import * as pathUtils from "../controller/utils/pathUtils";
import * as systemUtils from "../controller/utils/systemUtils";
import * as uuidUtils from "../controller/utils/uuidUtils";

const BACKEND_TOMATO_LOCAL = "http://localhost:9000";
const BACKEND_AI_SUGGESTION_LOCAL = "http://localhost:8080";

export const requestGeneration = async (
  model,
  options,
  chunkCallback,
  errorCallback,
  endCallback, 
  endpointTomato
) => {
  const api = endpointTomato
    ? endpointTomato
    : BACKEND_TOMATO_LOCAL;

  const bodyModel = await systemUtils.encGzipBase64(model);

  const body = JSON.stringify({
    model: bodyModel,
    options: options,
    type: "generation",
  });

  const onChunk = (response) => {
    const reader = response.body.getReader();
    const decoder = new TextDecoder();

    const readChunk = () => {
      return reader.read().then(appendChunks);
    };

    const appendChunks = (result) => {
      if (!result.done) {
        const chunk = decoder.decode(result.value || new Uint8Array(), { stream: !result.done });
        if (chunk) {
          chunkCallback(chunk);
        }
        return readChunk();
      }
    };

    return readChunk();
  };

  const onChunkComplete = () => {
    endCallback();
  };

  const onChunkError = (error) => {
    errorCallback(error);
  };

  fetch(api, {
    body,
    method: "POST",
    headers: new Headers({ "content-type": "application/json" }),
  })
    .then(onChunk)
    .then(onChunkComplete)
    .catch(onChunkError);
};

export const requestValidation = async (model, endpointTomato, afterCallback = () => {}) => {
  const api = endpointTomato
    ? endpointTomato
    : BACKEND_TOMATO_LOCAL;

  const bodyHash = MD5(model).toString();
  const bodyModel = await systemUtils.encGzipBase64(model);

  const body = JSON.stringify({
    model: bodyModel,
    hash: bodyHash,
    type: "validate",
  });

  const onChunk = (response) => {
    const reader = response.body.getReader();
    const decoder = new TextDecoder();

    const readChunk = () => {
      return reader.read().then(appendChunks);
    };

    const appendChunks = (result) => {
      if (!result.done) {
        const chunk = decoder.decode(result.value || new Uint8Array(), { stream: !result.done });
        if (chunk) {
          afterCallback(chunk);
        }
        return readChunk();
      }
    };

    return readChunk();
  };

  const onChunkComplete = () => {};

  const onChunkError = (error) => {
    afterCallback({ error: error.message });
  };

  fetch(api, {
    body,
    method: "POST",
    headers: new Headers({ "content-type": "application/json" }),
  })
    .then(onChunk)
    .then(onChunkComplete)
    .catch(onChunkError);
};

export const requestSuggestion = async (request) => {
  if (request.mock) {
    return requestSuggestionMock();
  }

  return requestSuggestionAPI(request);
};

const requestSuggestionAPI = async ({ controller, id, type, parent, root, prefix, linkedName, endpointAI }) => {
  if (!endpointAI) {
    return null;
  }

  const _api = configUtils.getMockSuggestions()
    ? `${BACKEND_AI_SUGGESTION_LOCAL}/suggestion`
    : `${endpointAI}/suggestion`;

  const _request = pathUtils.getAiSuggestionObject(id);

  _request.siblings = nodeUtils.getSiblingNames(parent, type);
  _request.type = type;

  if (prefix) {
    _request.prefix = prefix;
    _request.siblings.push(prefix);
  }

  if (linkedName) {
    _request.linkedName = linkedName;
  }

  if (root && root !== "") {
    _request.model = await systemUtils.encGzipBase64(root);
  }

  const _body = JSON.stringify(_request);
  const _signal = controller ? controller.signal : null;

  const _response = await fetch(_api, {
    body: _body,
    method: "POST",
    headers: new Headers({ "content-type": "application/json" }),
    signal: _signal,
  });

  if (_response.status !== 200) {
    const data = await _response.json();

    console.log(data.message);

    return { message: data.message, status: "error" };
  }

  let data = await _response.text();

  if (data.startsWith('"') && data.endsWith('"')) {
    data = data.substring(1, data.length - 1);
  }

  return { message: data, status: "ok" };
};

const requestSuggestionMock = async () => {
  await new Promise((e) => setTimeout(e, 2000));

  return { message: uuidUtils.createUuid(), status: true };
};
